import DOMPurify from 'dompurify';

// Pen test MOB-3: CMS-authored HTML (Storyblok rich text, Strapi markup) is rendered
// through `v-html`. Without sanitisation a malicious or compromised CMS entry becomes
// stored XSS running in the authenticated WebView origin (where the Auth0 tokens live).
// Sanitise every such string before it reaches the DOM.

// Force any target="_blank" link to also carry rel="noopener noreferrer" (reverse-
// tabnabbing hardening). Registered once at module load, not per call.
let hookRegistered = false;
function ensureHook() {
  if (hookRegistered) return;
  DOMPurify.addHook('afterSanitizeAttributes', node => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
  hookRegistered = true;
}

/**
 * Sanitise untrusted HTML for use with v-html.
 * Allows standard formatting HTML (no SVG/MathML) and strips scripts, event handlers,
 * javascript: URLs, and other XSS vectors. Preserves the inline emoji markup Storyblok
 * emits (`<img class="inline" ...>`) since img + class + safe inline style are allowed.
 *
 * @param {string} html
 * @returns {string} sanitised HTML (empty string for non-string / empty input)
 */
export function sanitizeHtml(html) {
  if (typeof html !== 'string' || html.length === 0) return '';
  ensureHook();
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    // Keep target so the afterSanitizeAttributes hook can pin rel="noopener" on
    // target="_blank" links (DOMPurify drops target by default).
    ADD_ATTR: ['target'],
  });
}
